export const linkFilterProcessor = ({ key, filterData, filter }) => {
	const options = filterData[key].map((option) => {
		return {
			href: filter.href ?? 'category',
			label: option[filter.labelKey ?? 'name'],
			count: option.count,
			params: filter.linkParameters ? filter.linkParameters.reduce((params, paramRef) => {
				return {
					...params,
					[paramRef.linkKey]: option[paramRef.filterKey],
				}
			}, {}) : undefined
		}
	});

	return {
		...filter,
		key,
		active: false,
		hidden: options.length === 0,
		options,
	}
}